<script setup>
defineProps({
  width: {
    type: Number,
    default: 16,
  },
  height: {
    type: Number,
    default: 16,
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="IconCheck">
      <path
        id="Vector"
        d="M5.71414 13.3337C5.49333 13.3337 5.27259 13.248 5.10409 13.0765L0.919208 8.81778C0.582269 8.4749 0.582269 7.91902 0.919208 7.57614C1.25608 7.23333 1.80245 7.23333 2.13932 7.57614L5.71414 11.214L13.8604 2.92416C14.1973 2.58127 14.7435 2.58127 15.0805 2.92416C15.4174 3.26704 15.4174 3.82291 15.0805 4.1658L6.3242 13.0765C6.15577 13.2479 5.93488 13.3337 5.71414 13.3337Z"
        fill="#00A8E8"
      />
    </g>
  </svg>
</template>
